export default "__VITE_ASSET__fOy_2L$j__"